var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSortable)?_c('md-icon',[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }